import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Eye, EyeOff, Lock } from 'lucide-react';

import { getApiBaseUrl } from '@/lib/apiBase';

const API = getApiBaseUrl();

const ChangePasswordPage = () => {
  const { token } = useAuth();
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [show, setShow] = useState({ current: false, new_: false, confirm: false });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  const toggleShow = (field) => setShow((s) => ({ ...s, [field]: !s[field] }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      toast.error('Новые пароли не совпадают');
      return;
    }
    if (form.new_password.length < 8) {
      toast.error('Новый пароль должен быть не менее 8 символов');
      return;
    }
    setLoading(true);
    try {
      await axios.patch(
        `${API}/auth/password`,
        { current_password: form.current_password, new_password: form.new_password },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast.success('Пароль успешно изменён');
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Ошибка смены пароля');
    } finally {
      setLoading(false);
    }
  };

  const PasswordInput = ({ name, label, showKey }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="relative">
        <input
          type={show[showKey] ? 'text' : 'password'}
          name={name}
          value={form[name]}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="button"
          onClick={() => toggleShow(showKey)}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          {show[showKey] ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );

  return (
    <div className="max-w-md mx-auto mt-10 px-4">
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <Lock className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900">Смена пароля</h1>
            <p className="text-sm text-gray-500">Минимум 8 символов</p>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <PasswordInput name="current_password" label="Текущий пароль" showKey="current" />
          <PasswordInput name="new_password" label="Новый пароль" showKey="new_" />
          <PasswordInput name="confirm_password" label="Подтвердите новый пароль" showKey="confirm" />
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Сохранение...' : 'Сохранить пароль'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
